import React, { useState } from 'react';

// --- Début des Icônes SVG ---

// Icône SVG pour "Lien Externe" (ExternalLink)
const ExternalLinkIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
    <polyline points="15 3 21 3 21 9"></polyline>
    <line x1="10" y1="14" x2="21" y2="3"></line>
  </svg>
);

// Icône SVG pour "Check"
const CheckIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <polyline points="20 6 9 17 4 12"></polyline>
  </svg>
);

// --- Fin des Icônes SVG ---


// J'ai remplacé les données des projets par vos domaines d'intervention
const interventions = [
  {
    id: 1,
    title: 'Villas et Appartements',
    category: 'Particuliers',
    image: 'https://images.unsplash.com/photo-1512917774080-9991f1c4c750?q=80&w=2070&auto=format=fit=crop',
    description: 'Protection complète pour votre domicile, de la cave au grenier, contre tous types de nuisibles.',
    details: ['Punaises de lit', 'Cafards', 'Rongeurs'],
    size: 'medium'
  },
  {
    id: 2,
    title: 'Restaurants et Cafés',
    category: 'Professionnels',
    image: 'https://www.franciscosegarra.com/wp-content/uploads/2022/03/decorations-restaurants.jpg',
    description: 'Solutions conformes aux normes HACCP pour garantir l\'hygiène et la sécurité de votre établissement.',
    details: ['Rongeurs', 'Insectes volants', 'Cafards'],
    size: 'large'
  },
  {
    id: 3,
    title: 'Bureaux et Commerces',
    category: 'Professionnels',
    image: 'https://v.seloger.com/s/crop/500x240/visuels/0/t/v/q/0tvqsppeoqf9u5x7i2kl7sn8zolt9hpgzbs61z6ow.jpg',
    description: 'Des interventions discrètes pour maintenir un environnement de travail sain et productif.',
    details: ['Dératisation', 'Désinsectisation', 'Contrats préventifs'],
    size: 'medium'
  },
  {
    id: 4,
    title: 'Écoles et Crèches',
    category: 'Professionnels',
    image: 'https://i.la-croix.com/1400x933/smart/2021/08/23/1201171926/Cours-mathematiques-classe-CE2-ecole-primaire-Saint-Herblain-Nantes-Loire-Atlantique-2021_0.jpg',
    description: 'Produits certifiés et méthodes sécurisées pour la protection des enfants et du personnel.',
    details: ['Traitements préventifs', 'Produits écologiques'],
    size: 'small'
  },
  {
    id: 5,
    title: 'Cliniques et Pharmacies',
    category: 'Professionnels',
    image: 'https://wikicom.ma/wp-content/uploads/2017/01/ITP-16nov1720.jpg',
    description: 'Protocoles stricts de désinfection et de décontamination pour les milieux sensibles.',
    details: ['Désinfection', 'Bactéricide', 'Virucide'],
    size: 'small'
  }
];

// Catégories mises à jour
const categories = ['Tous', 'Professionnels', 'Particuliers'];

export function PortfolioSection() {
  // Conversion de useState en JS
  const [activeCategory, setActiveCategory] = useState('Tous');
  const [hoveredProject, setHoveredProject] = useState(null);

  const filteredInterventions = activeCategory === 'Tous'
    ? interventions
    : interventions.filter(item => item.category === activeCategory);

  return (
    // J'ai mis un id "domaines" mais la nav pointe vers "pour-qui", j'ai remis "pour-qui"
    <section id="pour-qui" className="py-20 bg-background">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* En-tête de section - Mis à jour */}
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-foreground mb-4">
            Nos Domaines d'Intervention
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto mb-8">
            Découvrez les différents secteurs, professionnels et particuliers, pour lesquels 
            nous proposons des solutions sur mesure.
          </p>

          {/* Filtres de catégories - C'est déjà un <button> HTML, donc pas de changement */}
          <div className="flex flex-wrap justify-center gap-3">
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setActiveCategory(category)}
                className={`px-4 py-2 rounded-full font-medium transition-all ${
                  activeCategory === category
                    ? 'bg-primary text-white shadow-lg'
                    : 'bg-muted text-muted-foreground hover:bg-primary/10 hover:text-primary'
                }`}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
        {/* Grille des interventions - Remplacé <Card> par <div> */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredInterventions.map((item, index) => (
            // Remplacé <Card> par <div>
            <div
              key={item.id}
              className={`group cursor-pointer overflow-hidden border-0 shadow-lg hover:shadow-2xl transition-all duration-300 rounded-lg ${ // Ajout de rounded-lg
                item.size === 'large' ? 'md:col-span-2' : ''
              } ${item.size === 'small' ? 'lg:col-span-1' : ''}`}
              onMouseEnter={() => setHoveredProject(item.id)}
              onMouseLeave={() => setHoveredProject(null)}
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="relative overflow-hidden">
                {/* Remplacé <ImageWithFallback> par <img> */}
                <img
                  src={item.image}
                  alt={item.title}
                  className={`w-full object-cover transition-transform duration-300 group-hover:scale-110 ${
                    item.size === 'large' ? 'h-64' : 'h-48'
                  }`}
                  onError={(e) => e.target.src = `https://placehold.co/600x400/2d8a4a/white?text=${encodeURIComponent(item.title)}`}
                />
                
                {/* Superposition au survol - Remplacé <ExternalLink> par <ExternalLinkIcon> */}
                <div className={`absolute inset-0 bg-slate-blue/80 transition-opacity duration-300 ${
                  hoveredProject === item.id ? 'opacity-100' : 'opacity-0'
                }`}>
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="text-center text-white p-4">
                      <ExternalLinkIcon className="w-8 h-8 mx-auto mb-2" />
                      <p className="text-sm">Voir les détails</p>
                    </div>
                  </div>
                </div>

                {/* Badge de catégorie - Remplacé <Badge> par <div> */}
                <div className="absolute top-3 left-3">
                  <div className="bg-primary text-white px-2.5 py-0.5 rounded-md text-sm font-medium">
                    {item.category}
                  </div>
                </div>
              </div>

              {/* Remplacé <CardContent> par <div> */}
              <div className="p-6">
                <h3 className="text-xl font-semibold mb-2 text-foreground group-hover:text-primary transition-colors">
                  {item.title}
                </h3>
                
                {/* J'ai remplacé la localisation/date par les détails - Remplacé <Check> par <CheckIcon> */}
                <ul className="space-y-1 text-sm text-muted-foreground mb-3">
                  {item.details.map((detail) => (
                    <li key={detail} className="flex items-center gap-2">
                      <CheckIcon className="w-4 h-4 text-primary" />
                      <span>{detail}</span>
                    </li>
                  ))}
                </ul>

                <p className="text-muted-foreground text-sm leading-relaxed">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA en bas de page - C'est déjà un <button> HTML */}
        <div className="text-center mt-12">
          <button 
            className="bg-primary hover:bg-primary/90 text-white px-8 py-3 rounded-lg font-semibold transition-colors"
            onClick={() => document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' })}
          >
            Voir tous nos services
          </button>
        </div>
      </div>
    </section>
  );
}